import{FlexLayout}from"@wp/src/components/common/grid";import styled from"@emotion/styled";import IconContainer from"@wp/src/components/common/IconContainer";import Divider from"@wp/src/components/common/divider";import Modal from"@wp/src/components/common/modal";import{Button}from"@wp/src/components/common";export const AddNetworthAssetModal=styled(Modal)`
  .ant-modal-content {
    padding: 16px 24px;
  }
`;export const NetworthAssetListContainer=styled(FlexLayout)`
  border-radius: 8px;
  border: 1px solid ${props=>props.theme.colors.neutral300};
  background: ${props=>props.theme.colors.white};
  padding: 12px 16px;
`;export const NetworthAssetTypeContainer=styled(FlexLayout)`
  cursor: pointer;
`;export const NetworthAssetTypeText=styled(FlexLayout)``;export const NetworthAssetIcon=styled(IconContainer)`
  width: 40px;
  height: 40px;
`;export const NetworthAssetTypeActionsContainer=styled.div`
  margin-left: auto;
`;export const NetworthAssetTypeDivider=styled(Divider)`
  margin: 12px 0;
  padding: 0;
`;export const ManualCashPortfolioImporter=styled(Button)`
  &.ant-btn {
    margin: 0;
  }
}
`;